/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfigurationDto } from '../../models/configuration-dto';

export interface FindAll$Params {
  idUser: string;
}

export function findAll(
  http: HttpClient,
  rootUrl: string,
  params: FindAll$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<ConfigurationDto>>> {
  const rb = new RequestBuilder(rootUrl, findAll.PATH, 'get');
  if (params) {
    rb.path('idUser', params.idUser, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ConfigurationDto>>;
    })
  );
}

findAll.PATH = '/v1/configuration/{idUser}';
